import { useLocation, useNavigate } from 'react-router';
import { useLocale } from '@/i18n/useLocale';
import { buildPublishedLocaleUrl, parseLocalePrefixedPath } from '@/i18n/routing';

/** Offer only published languages; the current English-only site needs no selector. */
export function LocaleSwitcher() {
    const state = useLocale();
    const location = useLocation();
    const navigate = useNavigate();
    if (!state || state.manifest.locales.length < 2) return null;

    return (
        <select
            aria-label="Language"
            value={state.locale}
            className="rounded-md border border-white/30 bg-footer px-2 py-2 text-sm text-white focus-visible:outline focus-visible:outline-2"
            onChange={event => {
                const path = parseLocalePrefixedPath(location.pathname, state.manifest.locales.map(item => item.code));
                navigate(buildPublishedLocaleUrl(event.target.value, path.remainderPathname, location.search, location.hash));
            }}
        >
            {state.manifest.locales.map(item => <option key={item.code} value={item.code}>{item.label}</option>)}
        </select>
    );
}
